import React from "react";
import { motion } from "framer-motion";
import { Calendar, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { WHATSAPP_LINK } from "../../lib/constants";

function fmtDate(d) {
  if (!d) return "TBA";
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return d;
  }
}

export default function Events({ items = [], heading = true }) {
  return (
    <section className="bg-background py-24 md:py-32" data-testid="events-section">
      <div className="rb-container">
        {heading && (
          <Reveal className="mb-14">
            <p className="overline text-accent-foreground/60 mb-4 flex items-center gap-3">
              <span className="h-px w-10 bg-[var(--rb-gold)] inline-block" /> What's Coming
            </p>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-foreground max-w-2xl leading-[1.02]">
              Upcoming events &amp; workshops.
            </h2>
          </Reveal>
        )}

        <div className="space-y-6">
          {items.map((e, i) => (
            <motion.div
              key={e.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group grid md:grid-cols-[280px_1fr_auto] gap-6 md:gap-10 items-center border border-border hover:border-[var(--rb-gold)] bg-card transition-colors duration-400"
              data-testid={`event-card-${i}`}
            >
              <div className="img-zoom overflow-hidden h-52 md:h-44">
                <img src={e.image} alt={e.title} className="h-full w-full object-cover" loading="lazy" />
              </div>
              <div className="px-6 md:px-0 pb-4 md:py-6">
                <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-muted-foreground mb-3">
                  <span className="flex items-center gap-2"><Calendar className="h-4 w-4 text-[var(--rb-gold)]" /> {fmtDate(e.date)}</span>
                  {e.location && <span className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[var(--rb-gold)]" /> {e.location}</span>}
                </div>
                <h3 className="font-serif text-2xl md:text-3xl text-foreground leading-tight">{e.title}</h3>
                <p className="mt-2 text-muted-foreground max-w-xl leading-relaxed">{e.description}</p>
              </div>
              <div className="px-6 md:pr-8 pb-6 md:pb-0">
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" data-testid={`event-register-${i}`}
                   className="btn-outline-gold inline-flex px-6 py-3 text-sm font-semibold uppercase tracking-[0.15em] whitespace-nowrap">
                  Register
                </a>
              </div>
            </motion.div>
          ))}
          {items.length === 0 && (
            <p className="text-muted-foreground text-lg">No events scheduled right now — check back soon.</p>
          )}
        </div>
      </div>
    </section>
  );
}
